import React from 'react';
import * as Ons from 'react-onsenui';
import Toolbar from '../Toolbar';
import { supports } from '../../util/context';
import { translate as _ } from '../../util/i18n';

class PlayerListSettings extends React.Component {

    #groupOptions;
    #sortOptions;
    #viewOptions;

    constructor( props ) {

        super( props );

        this.state = {

            playerListSettings: this.props.playerListSettings

        };

        this.handleBackClick   = this.handleBackClick.bind( this );

        this.#groupOptions = [

            { value: null,       label: _( 'Keine'    ) },
            { value: 'position', label: _( 'Position' ) + ( supports( this.props.context, 'teamOfficials' ) ? ' / ' + _( 'Funktion' ) : '' ) }

        ];

        this.#sortOptions = [

            { value: null,       label: _( 'Name'     ) },
            { value: 'position', label: _( 'Position' ) + ( supports( this.props.context, 'teamOfficials' ) ? ' / ' + _( 'Funktion' ) : '' ) }

        ];

        this.#viewOptions = [

            { value: null,      label: _( 'Detailliert' ) },
            { value: 'compact', label: _( 'Kompakt'     ) }

        ];

        if ( supports( this.props.context, 'lineup' ) ) {

            this.#groupOptions.push( { value: 'line', label: _( 'Linie' ) } );
            this.#sortOptions.push(  { value: 'line', label: _( 'Linie' ) } );

        }

    }

    handleBackClick() {

        this.props.onUpdatePlayerListSettings( this.state.playerListSettings );

        this.props.onClose();

    }

    handleOptionClick( name, value ) {

        this.setState( { playerListSettings: { ...this.state.playerListSettings, [ name ]: value } } );

    }

    renderSetting( e ) {

        return (

            <Ons.List style={{ marginTop: '30px' }}>

                <Ons.ListHeader>{e.header}</Ons.ListHeader>

                {
                    e.options.map( ( option, i ) => {

                        const value = this.state.playerListSettings[ e.name ];

                        return (

                            <Ons.ListItem key={'option-' + i} onClick={() => this.handleOptionClick( e.name, option.value )} tappable={true}>

                                <div className="left"><Ons.Icon icon={value === option.value || ( option.value === null && ! value ) ? 'fa-check' : ''} fixedWidth={true} /></div>

                                <div className="center">{option.label}</div>

                            </Ons.ListItem>

                        );

                    } )
                }

            </Ons.List>

        );

    }

    render() {

        // console.log( 'components.Pages.PlayerListSettings.render()', this.props, this.state );

        return (

            <Ons.Page renderToolbar={() => <Toolbar onBackClick={this.handleBackClick} right={<span/>} />}>

                {this.renderSetting( { header: _( 'Sortieren nach'  ), options: this.#sortOptions,  name: 'sortBy'  } )}
                {this.renderSetting( { header: _( 'Gruppieren nach' ), options: this.#groupOptions, name: 'groupBy' } )}
                {this.renderSetting( { header: _( 'Ansicht'         ), options: this.#viewOptions,  name: 'view'    } )}

            </Ons.Page>

        );

    }

}

export default PlayerListSettings;